module.exports = __webpack_public_path__ + "static/img/1000.458cd37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/1000.png
// module id = 6wp/
// module chunks = 13